import { IBaseMapFilter, ILayerDetailsData, IMapData, IMapLayer } from "../../shared/models/map_models";
import { Feature } from "geojson"


export interface PointData {
    name: string;
    geo_location: {
      lat: number;
      lon: number;
    };
}
  
export interface GeoJSONFeature {
    type: 'Feature';
    geometry: {
      type: 'Point';
      coordinates: [number, number];
    };
    properties: any
}

export interface GeoJSONPolygon {
  type: 'Feature';
  geometry: {
    type: 'Polygon';
    coordinates: number[][][];
  };
  properties: any
}
  
export interface GeoJSONFeatureCollection {
    type: 'FeatureCollection';
    features: GeoJSONFeature[];
}

export interface ISelectedMapPoint {
  point: IMapData
  layer: IMapLayer,
  index?: number
}

export interface IMapLayerFeatures {
  layerId: number,
  features: Array<Feature>
}

export enum MapQueryParams {
  ActiveLayer = "activeLayer",
  ListViewLayer = "listViewLayer",
  FilterValues = "filterValues",
  VisibleLayers = 'visibleLayers'
}


export interface IMapLocation {
  lat: number,
  lng: number,
  zoom?: number,
  xOffset?: number,
  yOffset?: number,
}

export interface IMapFilter extends IBaseMapFilter {
  value: string | boolean
}

export interface IMapFilterParam {
  filterId: number,
  filterValue: string
}

export interface IEnhancedLayerDetailsData extends ILayerDetailsData {
  displayValue: any
}